import fitty from 'fitty';
import Typed from 'typed.js';

document.addEventListener('DOMContentLoaded', function() {

    const stickerForm = document.getElementById('stickerForm'),
          stickerInput = document.getElementById('stickerInput'),
          stickers = document.getElementsByClassName('js-sticker');

    const init = function() {

        let typed;

        const action = function(e) {

            let value = stickerInput.value.replace(/<\/?[^>]+(>|$)/g, "").substring(0, 15);

            typed != undefined ? typed.destroy() : false;

            typed = new Typed('.js-stickerTyping', {
                strings: [value],
                typeSpeed: 60,
                contentType: null,
                showCursor: false
            });

            for (let i = 0; i < stickers.length; i++) {
                stickers[i].innerHTML = value;
            }

            e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
        };

        stickerForm.addEventListener('submit', action);
    };

    fitty('#fittySticker', {
        maxSize: 32
    });

    stickerInput ? init() : false;

}, false);



